import { useLabelStatusTag } from "@easybiz/component";
import { Tag } from "antd";
import React from "react";

export default ({ order, sortIndex, checkProcedure }) => {
  const { backgroundColor, title } = useLabelStatusTag(order, sortIndex, checkProcedure);

  return <Tag style={{ backgroundColor, color: "white" }}>{title}</Tag>;
};
